import { useLocation } from "@tanstack/react-router";

/**
 * Builds language-aware paths. On a /$lang/... route it prefixes the lang;
 * on the default (oz) routes it returns the path unchanged.
 *   const lp = useLangPath();  lp("/register") -> "/register" or "/uz/register"
 */
export function useLangPath() {
  const { pathname } = useLocation();
  const seg = pathname.split("/").filter(Boolean)[0];
  const lang = ["uz", "ru", "en"].includes(seg) ? seg : null;
  return (path: string) => (lang ? `/${lang}${path}` : path);
}
